import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " श्री.चेतन जी.कंगाले ", designation: "ग्रामपंचायत वलनी.", },
  { name: "श्री.कुमार मु.ठाकरे", designation: "ग्रामपंचायत वलनी", },
  { name: "सौ.श्वेता वी.बेडे", designation: "ग्रामपंचायत वलनी", },
  { name: "सौ.निलु सु.तेलंगे", designation: "ग्रामपंचायत वलनी", },
  { name: "सौ.कल्पना पि. रामगुंडे ", designation: "ग्रामपंचायत वलनी",},
  { name: "सौ.बेबी वि. गोमासे", designation: "ग्रामपंचायत वलनी",},
];

const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2025 Gram Panchayat — All Rights Reserved.
      </div>
    </div>
  );
};

export default GPTeam;